/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Information = 'Website.Product.Videos.Information';
export const Review = 'Website.Product.Videos.Review';
export const HowTo = 'Website.Product.Videos.HowTo';
export const VideolySpecs = 'Website.Product.Videos.VideolySpecs';
export const VideolyPresentation = 'Website.Product.Videos.VideolyPresentation';
export const VideolyReview = 'Website.Product.Videos.VideolyReview';
export const VideolyHowTo = 'Website.Product.Videos.VideolyHowTo';
export const VideolyComparison = 'Website.Product.Videos.VideolyComparison';
export const VideolyUnboxing = 'Website.Product.Videos.VideolyUnboxing';
export const VideolyBrand = 'Website.Product.Videos.VideolyBrand';
export const VideolyInspiration = 'Website.Product.Videos.VideolyInspiration';
